import { render, staticRenderFns } from "./IQSidebar.vue?vue&type=template&id=dec32702&scoped=true"
import script from "./IQSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./IQSidebar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQSidebar.vue?vue&type=style&index=0&id=dec32702&prod&scoped=true&lang=css"
import style1 from "./IQSidebar.vue?vue&type=style&index=1&id=dec32702&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec32702",
  null
  
)

export default component.exports